module.exports = "https://static.energy5.com/_next/static/images/step4Image-9bbde77b94b45a8120c684f8fbd46e81.jpg";